import { makeStyles } from "@material-ui/core";
import React from "react";
import Chip from "../assets/chip.svg";
import Visa from "../assets/visa.svg";
import Mastercard from "../assets/mastercard.svg";
import Amex from "../assets/amex.svg";
import classNames from "classnames";

const useStyles = makeStyles((theme) => ({
  card: {
    color: theme.app.secondaryColor,
    height: "200px",
    width: "350px",
    padding: "3rem 0.5rem 0.5rem 2.5rem",
    backgroundImage:
      "linear-gradient(to right bottom, rgba(255, 255, 255, 1), rgba(242, 242, 242, 1))",
    boxShadow: theme.shadows[3],
    borderRadius: "10px",
  },
  screenReader: {
    position: "absolute",
    zIndex: "-1000",
    width: "100%",
    height: "100%",
  },
  chip: {
    display: "block",
    height: "30px",
    borderRadius: "3px",
    marginBottom: "5px",
  },
  cardNumber: {
    position: "relative",
    display: "flex",
    gap: "30px",
    fontSize: "22px !important",
  },
  validContainer: {
    display: "grid",
    gap: "5px",
    gridTemplateColumns: "repeat(5, 1fr)",
  },
  validLabelContainer: {
    gridColumnStart: "2",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  validLabel: {
    display: "flex",
    flexDirection: "column",
    fontSize: "7px !important",
    alignItems: "flex-end",
  },
  validDate: {
    position: "relative",
    gridColumnStart: "3",
    fontSize: "20px !important",
  },
  iconContainer: {
    height: "50px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "Center",
  },
  icon: {
    width: "65px",
  },
}));

const getIcon = (initialNumber, classes) => {
  switch (initialNumber) {
    case "4":
      return <img src={Visa} alt="Visa" className={classes.icon} />;
    case "2":
    case "5":
      return <img src={Mastercard} alt="Mastercard" className={classes.icon} />;
    case "3":
      return <img src={Amex} alt="American Express" className={classes.icon} />;
    default:
      return null;
  }
};

const Card = ({ cardData }) => {
  const classes = useStyles();

  const { maskedCardNumber, cardExpiryMonth, cardExpiryYear } = cardData;

  const cardNumber1 = maskedCardNumber.slice(0, 4);
  const cardNumber2 = maskedCardNumber.slice(4, 8);
  const cardNumber3 = maskedCardNumber.slice(8, 12);
  const cardNumber4 = maskedCardNumber.slice(12, 16);

  return (
    <div className={classes.card}>
      <img className={classes.chip} src={Chip} alt="chip" />
      <div
        aria-label="Kortnummer"
        className={classNames(classes.cardNumber, "cardFont")}
      >
        <div className={classes.screenReader}>Kortnummer</div>
        <span>{cardNumber1}</span>
        <span>{cardNumber2}</span>
        <span>{cardNumber3}</span>
        <span>{cardNumber4}</span>
      </div>
      <div className={classNames(classes.validContainer, "cardFont")}>
        <div className={classes.validLabelContainer}>
          <p aria-hidden className={classes.validLabel}>
            <span>VALID</span>
            <span>THRU</span>
          </p>
        </div>
        <p className={classes.validDate}>
          <span className={classes.screenReader}>
            Giltighetsdatum, månad/år
          </span>
          {cardExpiryMonth}/{cardExpiryYear}
        </p>
      </div>
      <div className={classes.iconContainer}>
        {getIcon(maskedCardNumber[0], classes)}
      </div>
    </div>
  );
};

export default Card;
